import { defineMessages } from 'react-intl-next';

export const messages: {
    contentHeader: {
        defaultMessage: string;
        description: string;
        id: string;
    }; contentSubHeader: {
        defaultMessage: string;
        description: string;
        id: string;
    }; description: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lozengeTitle: {
        defaultMessage: string;
        description: string;
        id: string;
    }; placeHolderTitle: {
        defaultMessage: string;
        description: string;
        id: string;
    }; title: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	title: {
		id: 'company-hub.section-extension.manifest.extension-title',
		defaultMessage: 'Section [New]',
		description: 'Title of section extension to be displayed in shortcut macros dropdown.',
	},
	lozengeTitle: {
		id: 'company-hub.section-extension.manifest.extension-lozenge-title',
		defaultMessage: 'Section',
		description: 'Title of section extension to be displayed in lozenge',
	},
	description: {
		id: 'company-hub.section-extension.manifest.macro-description',
		defaultMessage: 'Group elements together with a background',
		description:
			'Description of section extension to be displayed in toolbar/shortcut macros dropdown',
	},
	contentHeader: {
		id: 'company-hub.section-extension.manifest.content.header',
		defaultMessage: 'Give your section a title',
		description: "Header of section extension's initial content",
	},
	contentSubHeader: {
		id: 'company-hub.section-extension.manifest.content.sub-header',
		defaultMessage: 'Organize elements into sections with customizable backgrounds.',
		description: "Sub-header of section extension's initial content",
	},
	placeHolderTitle: {
		id: 'company-hub.section-extension.manifest.content.placeholder-title',
		defaultMessage: 'Placeholder',
		description:
			'Title of hub element placeholder extension to be displayed the macro is presented in the editor.',
	},
});
